export class ReservationApiError extends Error {
    constructor(status, errors = null) {
        super('Reservation API request failed')

        this.name = 'ReservationApiError'
        this.status = status
        this.errors = errors
    }
}

const postJson = async (path, payload) => {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
    }

    if (csrfToken) {
        headers['X-CSRF-TOKEN'] = csrfToken.content
    }

    const response = await fetch(path, {
        method: 'POST',
        credentials: 'same-origin',
        cache: 'no-store',
        headers,
        body: JSON.stringify(payload),
    })

    let body

    try {
        body = await response.json()
    } catch (error) {
        throw new ReservationApiError(response.status)
    }

    if (
        !response.ok ||
        !body ||
        body.errors ||
        body.success === false ||
        body.status === false
    ) {
        throw new ReservationApiError(
            response.status,
            body && body.errors ? body.errors : null,
        )
    }

    return body
}

const calculatePromotions = async (payload) => {
    let result

    try {
        result = await postJson(
            '/reservation/calculate_promotions',
            payload,
        )
    } catch (error) {
        if (
            !(error instanceof ReservationApiError) ||
            ![404, 405].includes(error.status)
        ) {
            throw error
        }

        result = await postJson('/reservation/check_reservation', {
            ...payload,
            calculatePromotionsPreview: true,
        })
    }

    if (!result.success || !result.promotions) {
        throw new ReservationApiError(200)
    }

    return result.promotions
}

const captureUddsRecovery = async (payload) => {
    const result = await postJson('/reservation/checkout-recovery/udds', payload)

    if (result.success !== true || typeof result.captured !== 'boolean') {
        throw new ReservationApiError(200)
    }

    return {
        captured: result.captured,
    }
}

export const reservationApi = {
    getOffer: (payload) =>
        postJson('/api_reservation/get_offer', payload),

    getInsurances: (payload) =>
        postJson('/reservation/get_insurances', payload),

    getParkingAirports: (payload) =>
        postJson('/reservation/get_parking_airports', payload),

    getParkingOffers: (payload) =>
        postJson('/reservation/get_parking_offers', payload),

    makeReservation: (payload) =>
        postJson('/reservation/make', payload),

    calculatePromotions,
    captureUddsRecovery,
}
